$(document).ready(function(){
  
function inventoryAjax(varientArray){

  var AUS_Left = $('.customJTPL-DelivaryShow').attr('pau-avl');
  var NZ_Left = $('.customJTPL-DelivaryShow').attr('pnz-avl');
  var China_LEFT = $('.customJTPL-DelivaryShow').attr('china-avl');

    $.ajax({
      url: "/a/inventory/index.php",
      type: "POST",
      dataType: "HTML",
      data: {varientArray},
      crossDomain: true,
      success: function(Data){
        var new_Data = Data.trim()
        console.log("success")
        console.log("Data Here Data : " + new_Data);
        if(new_Data == 'Australia'){
          $(".ShippingTextjtpl").html(AUS_Left);
        } 
          else if(new_Data == 'New Zealand'){
            $(".ShippingTextjtpl").html(NZ_Left);
        }
        else if(new_Data == 'China'){
            $(".ShippingTextjtpl").html(China_LEFT);
        }
        else{
         $(".ShippingTextjtpl").html("");
        }
      },
      error: function(){
        console.log("error" + varientArray)
      }
      
    })
}
  
  if($("h1.product__title.jtpl_ctm").attr("data-attr-cstm_id") !== undefined){
  var product_id = $("h1.product__title.jtpl_ctm").attr("data-attr-cstm_id");
  var variant_id = $("h1.product__title.jtpl_ctm").attr("data-attr-cstm_variant_id");
    console.log('abc ' + product_id);
      var varientArray = [product_id , variant_id];
    
    console.log("array : " + varientArray)
    inventoryAjax(varientArray);
 }else{

  // setTimeout(function() {
  //     $("[varient_clk]").trigger('click');
  //   },10);
     setTimeout(function() {
    var id = $(".single-option-selector[checked='checked']").attr("id");
    if($(".single-option-selector[checked='checked']").length > 0 ){
       console.log($(".single-option-selector[checked='checked']").attr("id"));
       $("label[for="+id+"]").trigger('click');
    }
    },200);

  // Varient Canada USA Shipping Text Begin.

    $(document).on('click','[varient_clk]',function(){
  // alert('helo');
    var product_id = $(this).attr('product_id');
    var variant_id = $(this).attr('varient_id');
    var varientArray = [product_id , variant_id];
      inventoryAjax(varientArray);
    // console.log("array : " + varientArray)
    // console.log("Product ID : " + product_id)
    // console.log("Varient ID : " + variant_id)
  });
}

  // Varient Canada USA Shipping Text End.

});